/**
 * Admin Space Reports API client (P4).
 * Wraps GET /admin/space-reports + POST /admin/space-reports/:id/resolve.
 */

import type {
  AdminResolveReportRequest,
  AdminResolveReportResponse,
  AdminSpaceReportsResponse,
  PublicSpaceItemReportStatus,
} from "@hasheeai/types";
import { apiFetch } from "./client";

export type AdminSpaceReportsListFilter = PublicSpaceItemReportStatus | "all";

type ListParams = {
  readonly status?: AdminSpaceReportsListFilter;
  readonly cursor?: string | null;
  readonly limit?: number;
};

export async function fetchAdminSpaceReports(
  params: ListParams,
): Promise<AdminSpaceReportsResponse> {
  const sp = new URLSearchParams();
  if (params.status) sp.set("status", params.status);
  if (params.cursor) sp.set("cursor", params.cursor);
  if (params.limit) sp.set("limit", String(params.limit));
  const qs = sp.toString();
  return apiFetch<AdminSpaceReportsResponse>(
    qs ? `/admin/space-reports?${qs}` : "/admin/space-reports",
  );
}

export async function resolveAdminSpaceReport(
  reportId: string,
  body: AdminResolveReportRequest,
): Promise<AdminResolveReportResponse> {
  return apiFetch<AdminResolveReportResponse>(
    `/admin/space-reports/${encodeURIComponent(reportId)}/resolve`,
    { method: "POST", body: JSON.stringify(body) },
  );
}
